import { Container} from "@mui/material";
import LoadingScreen from "../components/loadingScreen";

export default function LoadingPage(){
    return <Container maxWidth="sm">
            <LoadingScreen/>
        </Container>

}
